export default __webpack_public_path__ + "static/media/linkedin.ee63976b.svg";